import { getAccessTokenSilently } from "utils/functions";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { Pagination } from "@material-ui/lab";
import AuthService from "Lib/API/Auth";
import { ReactComponent as AddUserSVG } from "assets/icons/add-user.svg";
import DefaultUserOPNG from "assets/icons/default-user.png";
import Button from "components/button/Button";
import { formatDate } from "helper/dateFormat";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Link, useHistory } from "react-router-dom";
import { familyMembers } from "services/api/dashboard";
import Action from "../../components/ActionPopOver";
import MyModal from "../../components/MyModal";
import MyTable from "../../components/Table";
import { withUserExist } from "../CustomHooks";
import { addMemmberUrl } from "../commonSlice";
import "./index.scss";
import AddNewUser from "./newUser.js";
import { Fonts, FontColors } from "theme/fontConfig";

const styles = {
  titleCard: {
    fontSize: Fonts.GeneralHeaderFont.fontSize,
    color: FontColors.Slate464E5F,
    marginLeft: `12px`,
    fontWeight: Fonts.GeneralHeaderFont.fontWeight,
  },
  buttonCardBody: {
    background: "#F2F6FD",
    minHeight: 70,
    minWidth: 80,
    borderRadius: 5,
  },
};

const FamilyMembersTab = () => {
  const [loading, setLoading] = useState(false);
  const [openNewMember, setOpenNewMember] = useState(false);
  const [myData, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const dispatch = useDispatch();
  const family_members = useSelector(
    (state) => state?.dashboardData?.family_members
  );
  let allMembers = family_members;
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:600px)");
  const rowsPerPage = 30;
  const enableLoading = (value) => {
    setLoading(value);
  };

  const { disableEditingOnMemberPortal } = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : {};

  // const fetchMyAPI = async () => {
  //   const accountID = localStorage.getItem("accountID");
  //   console.log(accountID, "accountID");
  //   const token = await getAccessTokenSilently();
  //   await AuthService.getFamilyMember(token, accountID)
  //     .then((res) => {
  //       const data = res ? res[0]?.family_members : "" || [];
  //       data.map((item) => {
  //         item.id = item._id;
  //         return item;
  //       });
  //       console.log(data, "familyMembers");
  //       // dispatch(familyMembers(data));
  //       enableLoading(false);
  //     })
  //     .catch((err) => {
  //       enableLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   fetchMyAPI();
  // }, [refresh]);
  const MyAPI = async () => {
    const accountID = localStorage.getItem("accountID");
    console.log(accountID, "accountID");
    const token = await getAccessTokenSilently();
    await AuthService.getFamilyMember(page + 1, 30, token)
      .then((res) => {
        const data = res?.contacts ? res?.contacts : [];
        console.log(data, "Asdfasdf");
        setCount(res?.total);
        dispatch(familyMembers(data));
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error("Error", err?.data?.message);
      });
  };

  useEffect(() => {
    MyAPI();
  }, [refresh, page]);

  console.log(count, "family_members");

  const familyMembersActions = (data) => {
    const member = data?.row;
    const actions = {
      ...(disableEditingOnMemberPortal
        ? {
            onViewClick: () => {
              history.push(`add-new-member`, {
                member_to_edit: member,
                view_only: true,
              });
            },
          }
        : {
            onEditClick: () => {
              history.push(`add-new-member`, {
                member_to_edit: member,
                view_only: false,
              });
            },
            onDeleteClick: () => handleDelete(data?.id),
          }),
    };
    return actions;
  };

  const handleDelete = async (id) => {
    if (id) {
      const input = {
        contactID: id,
      };
      const token = await getAccessTokenSilently();
      await AuthService.removeMember(input, token)
        .then((res) => {
          enableLoading(false);
          setRefresh(true);
          // fetchMyAPI();
        })
        .catch((err) => {
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
  };
  const columns = [
    {
      field: "first_name",
      headerName: "NAME",
      resizable: true,
      flex: 1,
      minWidth: 180,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home">
            <img
              alt="profile_img"
              src={data?.row?.profile_img || DefaultUserOPNG}
              style={{ width: "50px", height: "50px", borderRadius: "3px" }}
            />
            <div className="name-container">
              <div
                className="name-container-inner"
                onClick={() => {
                  history.push(`add-new-member`, {
                    member_to_edit: data?.row,
                    view_only: disableEditingOnMemberPortal,
                  });
                }}
              >
                <p className="id-container">
                  {data?.row?.first_name + " " + data?.row?.last_name}
                </p>
              </div>
              {/* <p style={{ color: "#B5B5C3" }}>{data?.row?.hebrew_name}</p>
              <p
                style={{
                  color: `${
                    data?.row?.gender === "Male" ? "#a0bcf0" : "#efa7aa"
                  }`,
                  opacity: "0.6",
                }}
              >
                {data?.row?.gender || "-"}
              </p> */}
            </div>
          </div>
        );
      },
    },
    {
      field: "account_permission",
      headerName: "FAMILY ADMIN",
      resizable: true,
      minWidth: 130,
      renderCell: (data) => (
        <div
          style={{
            color: FontColors.Slate4D5565,
            marginLeft: "30px",
            fontSize: Fonts.GeneralBodyFont.fontSize,
            fontFamily: Fonts.GeneralBodyFont.fontFamily,
          }}
        >
          {data?.row?.account_permission === "admin" ? "YES" : "NO"}
        </div>
      ),
    },
    {
      field: "gender",
      headerName: "SEX",
      minWidth: 90,
      renderCell: (data) => (
        <div
          className="row-data-gender"
          style={{ color: FontColors.Slate4D5565, fontSize: Fonts.GeneralBodyFont.fontSize, fontFamily: Fonts.GeneralBodyFont.fontFamily }}
        >
          {data.row.gender ? data.row.gender : "-"}
        </div>
      ),
    },
    {
      field: "date_of_birth",
      headerName: "DOB",
      minWidth: 120,
      renderCell: (data) => (
        <div
          className="row-data-gender"
          style={{ color: FontColors.Slate4D5565, fontSize: Fonts.GeneralBodyFont.fontSize, fontFamily: Fonts.GeneralBodyFont.fontFamily }}
        >
          {data.row.date_of_birth
            ? formatDate({
                date: data.row.date_of_birth,
                formatType: "defaultWithUTC",
              })
            : "-"}
        </div>
      ),
    },
    {
      field: "relationship",
      headerName: "RELATIONSHIP",
      minWidth: 130,
      renderCell: (data) => (
        <div
          className="row-data-gender"
          style={{ color: FontColors.Slate4D5565, fontSize: Fonts.GeneralBodyFont.fontSize, fontFamily: Fonts.GeneralBodyFont.fontFamily }}
        >
          {data?.row?.relationship?.[0] ?? "-"}
        </div>
      ),
    },
    {
      field: "action",
      headerName: `${" "}`,
      minWidth: 80,
      renderCell: (data) => (
        <div className="row-data-gender">
          <Action {...familyMembersActions(data)} />
        </div>
      ),
    },
  ];

  const openRecord = (member) =>
    history.push("add-new-member", {
      member_to_edit: member,
      view_only: disableEditingOnMemberPortal,
    });

  const addButton = !disableEditingOnMemberPortal && (
    <Button variant="primary" onClick={() => setOpenNewMember(true)} className="mr-2">
      <span>Add a family member</span>
    </Button>
  );

  const modal = (
    <MyModal
      className="new-charge-modal"
      open={openNewMember}
      onClose={() => setOpenNewMember(false)}
    >
      <AddNewUser setOpen={setOpenNewMember} setRefresh={setRefresh} refresh={refresh} />
    </MyModal>
  );

  const pagination = (
    <div className="pagination-custom mt-2">
      <Pagination
        count={Math.ceil(count / 30)}
        color="primary"
        variant="outlined"
        onChange={(event, value) => setPage(value - 1)}
      />
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          {addButton}
          {modal}
        </div>
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", overflow: "hidden" }}>
          {allMembers?.map((member, i) => (
            <div
              key={member._id ?? i}
              onClick={() => openRecord(member)}
              style={{
                padding: "14px 16px",
                borderBottom: i < allMembers.length - 1 ? "1px solid #F1F5F9" : "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span style={{ ...Fonts.GeneralLabelFont, color: FontColors.Slate0F172A }}>
                {member.first_name} {member.last_name}
              </span>
              <span style={{ color: FontColors.Slate94A3B8, fontSize: Fonts.GeneralXLargeBodyFont.fontSize, lineHeight: 1 }}>›</span>
            </div>
          ))}
        </div>
        {pagination}
      </div>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <h2 style={{ margin: 0, ...Fonts.GeneralHeaderFont, color: FontColors.Slate0F172A }}>
          Family Members
        </h2>
        <div style={{ display: "flex", gap: 8 }}>
          {addButton}
          {modal}
        </div>
      </div>
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          border: "1px solid #E2E8F0",
          padding: 16,
        }}
      >
        <div style={{ height: (allMembers?.length || 0) * 65 + 56 }}>
        <MyTable
          className="data-table"
          rowHeight={65}
          rows={allMembers}
          columns={columns}
          pageSize={30}
          rowsPerPageOptions={[30]}
          disableSelectionOnClick
          hideFooterPagination
          loading={loading}
        >
          Rows per page: {rowsPerPage}
        </MyTable>
        </div>
        {pagination}
      </div>
    </div>
  );
};
export default withUserExist(FamilyMembersTab);
